import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LogIn, ArrowLeft } from "lucide-react";
import { api, formatErr } from "../lib/api";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const nav = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post("/auth/login", { email, password });
            localStorage.setItem("hol_admin_token", data.token);
            localStorage.setItem("hol_admin_name", data.name);
            toast.success("Welcome back.");
            nav("/admin");
        } catch (err) {
            toast.error(formatErr(err.response?.data?.detail) || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="admin-login-page" className="min-h-screen bg-[#050507] text-white flex flex-col">
            <div className="max-w-7xl mx-auto w-full px-6 sm:px-10 lg:px-16 py-8">
                <a href="/" data-testid="back-home" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-[#D4AF37]">
                    <ArrowLeft size={14} /> Back to site
                </a>
            </div>

            <div className="flex-1 grid place-items-center px-6 pb-24">
                <div className="w-full max-w-md">
                    <div className="text-center mb-10">
                        <img src="/lead-krafts-icon.png" alt="Lead Krafts" className="mx-auto h-14 w-14 object-contain mb-6" />
                        <div className="overline">Admin Console</div>
                        <h1 className="mt-3 font-serif-display text-4xl">
                            Sign <span className="italic text-[#D4AF37]">in</span>
                        </h1>
                    </div>

                    <form onSubmit={submit} className="bg-[#0A0B10] border border-[#D4AF37]/25 p-8 space-y-5">
                        <label className="block">
                            <span className="text-xs uppercase tracking-widest text-white/50 mb-2 block">Email</span>
                            <input
                                data-testid="admin-email"
                                type="email"
                                className="hol-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="admin@leadkrafts.com"
                                required
                            />
                        </label>
                        <label className="block">
                            <span className="text-xs uppercase tracking-widest text-white/50 mb-2 block">Password</span>
                            <input
                                data-testid="admin-password"
                                type="password"
                                className="hol-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </label>
                        <button
                            type="submit"
                            data-testid="admin-login-submit"
                            disabled={loading}
                            className="btn-gold w-full justify-center disabled:opacity-60"
                        >
                            {loading ? "Signing in..." : (<>Sign in <LogIn size={16} /></>)}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
